// Version : 0.0.1
// Author : SATHISH
// LastEdit : SHIYAM
// MODFIED DATE: 26-09-2025
// Last ADD : Removed excel related code and added command lines

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PreCloseReportActionTypes from './preclose-loan-report.types';
import { precloseReportListGet } from './preclose-loan-report.service';
import {
	getPrecloseReportDetailsSuccess,
	getPrecloseReportDetailsFailure,
	getPrecloseReportDetailsResponseChanged,
} from './preclose-loan-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET PRECLOSE REPORT DETAILS  ******************** */
export function* getPrecloseReportList({ payload }: any) {
	try {
		const key = 'GetMemberPreCloseKey';
		const jsonData = {
			CompanyID: payload.companyID,
			BranchID: payload.branchID,
			CenterID: payload.centerID,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			TillDate: payload.TillDate,
			DateFilter: payload.datefilter,
			LoanIndexType: payload.type,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(precloseReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPrecloseReportDetailsFailure(responseData.data));
		} else {
			yield put(getPrecloseReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPrecloseReportDetailsFailure(error));
	}
}

export function* resetGetPrecloseReportListResponse() {
	yield put(getPrecloseReportDetailsResponseChanged());
}

export function* onGetPrecloseReportListDetails() {
	yield takeLatest(
		PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_START,
		getPrecloseReportList,
	);
}

export function* onGetPrecloseReportListResponseReset() {
	yield takeLatest(
		PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_RESPONSE_RESET,
		resetGetPrecloseReportListResponse,
	);
}
/** *********************  END GET PRECLOSE REPORT LIST ******************** */

export function* reportPrecloseSaga() {
	yield all([call(onGetPrecloseReportListDetails), call(onGetPrecloseReportListResponseReset)]);
}
